import { MiddlewareAPI, AnyAction, Dispatch } from 'redux';
import State from 'store/State';
import Services from 'store/Services';
import { LayoutAction, LayoutActionType } from 'layout/store/actions';
import { selectLayoutComponents } from 'layout/store/selectors';
import { LayoutStatus } from 'layout/LayoutState';
import { cleanupWidgetSharedStateAction } from './actions';
import { removeDuplicates } from 'utils/arrays/arrayUtils';

export function updateWidgetsSharedStateMiddleware({
    widgetsService,
}: Services) {
    return (middlewareAPI: MiddlewareAPI<Dispatch<AnyAction>, State>) =>
        (next: Dispatch<AnyAction>) =>
        (action: LayoutAction) => {
            next(action);

            if (
                action.type !== LayoutActionType.LAYOUT_STATE_CHANGE ||
                !action.payload ||
                !action.payload.layoutState ||
                action.payload.layoutState.status !== LayoutStatus.SUCCESS
            ) {
                return;
            }

            const state = middlewareAPI.getState();
            const componentsInLayout = selectLayoutComponents(state);

            const sharedStateWidgetSections = componentsInLayout
                .map((x) => x.type)
                .filter(removeDuplicates)
                .flatMap((widgetType) =>
                    widgetsService.getSharedStateSections(widgetType)
                )
                .filter(removeDuplicates);

            middlewareAPI.dispatch(
                cleanupWidgetSharedStateAction(sharedStateWidgetSections)
            );
        };
}
